import imagesLoaded from 'imagesloaded'
import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { shuffle } from '../utils/utils';

GSAP.registerPlugin(ScrollTrigger)

export default class HeroCollage {
	constructor(el) {

		this.element 			= el
		this.images 			= el.querySelectorAll('.hero-collage__img')
		this.imageWrappers 		= [...el.querySelectorAll('.hero-collage__slotmachineimg')]
		this.scrollingSection 	= el.querySelectorAll('.hero-collage__gallery')
		this.slots 				= [...el.querySelectorAll('.hero-collage__slot')]
		this.introAnimation 	= this.introAnimation.bind(this)
		this.columnAnimation 	= this.columnAnimation.bind(this)
		this.loadingAnimation	= GSAP.timeline()
		this.startY				= ['-11%','-10%','-9%','-8%','-7%']
		this.moveY				= ['-15%','-11%','-8%','-6%','-5%']
		
		
		if(this.slots) {
			// console.log(this.slots)
			shuffle(this.slots)
		}

		this.loadingAnimation = GSAP.to(this.imageWrappers, {
			ease: 'power1.out',
			// duration: 500,
			opacity: 1,
			y: 0,
			stagger: 0.03,
			delay: 0.5,
			paused: true
		})

		// FIRST WE NEED AN INTRO ANIMATION
		// The animation must fire only when the hero is in the viewport and the images are loaded
		if(this.images){
			GSAP.set(this.imageWrappers, {
				opacity: 0,
				y: '400px',
			});
			this.slots && this.slots.forEach( (slot,i) => {

				GSAP.set(slot, {
					y: this.startY[i],
				});

			});
			new imagesLoaded(this.images, () => {
				this.introAnimation()
			});
		}

	}

	introAnimation() {
		// console.log('images loaded!')

		// create intersection observer to determine if the hero is in the viewport
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting){
					// Once in the viewport, play the loading animation and start the column animation
					this.loadingAnimation.play()
					this.columnAnimation()
					observer.disconnect()
				}
			})
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0.01
		})

		observer.observe(this.element)

	}

	columnAnimation() {

		// PIN THE BLOCK TO SCROLL THROUGH IT
		this.scrollingAnimation = GSAP.timeline({
			scrollTrigger: {
				trigger: this.element,
				start: 'top top',
				end: 'bottom top',
				// markers: true,
				scrub: true,
				// pin: true,
			},
		});

		this.slots && this.slots.forEach( (slot,i) => {

			this.scrollingAnimation.to(slot, {
				y: this.moveY[i],
				// ease: 'power1.out',
				stagger: 0.1,
				// onComplete() {
				// 	console.log('slot moved')
				// },
			}, "<");

		});
	}
	  

}
